// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2yi9x","col":"styles_col__3u_4K"};